module.exports = __webpack_public_path__ + "static/media/lock_close.8fab59a9.svg";